import { isSubscriptionPurchase, isSinglePurchase } from "../../../../../../../../../../types/types/typeguards.js";
const mapSolutionToDraftLineItem = ({
  sku,
  state,
  purchaseType,
  priceSegment
}) => {
  const { deliveryInterval } = state.configurations.subscriptionPurchaseConfigurations;
  const lineItemDraft = {
    sku,
    quantity: state.configurations.quantity,
    type: "regular"
  };
  if (isSubscriptionPurchase(purchaseType)) {
    if (!deliveryInterval) {
      return;
    }
    lineItemDraft.typeDetails = {
      isSubscription: true,
      subscriptionDetails: {
        deliveryInterval
      }
    };
  } else if (isSinglePurchase(purchaseType) && priceSegment) {
    lineItemDraft.typeDetails = {
      segments: [{ channelKey: priceSegment }]
    };
  }
  return lineItemDraft;
};
export {
  mapSolutionToDraftLineItem
};
//# sourceMappingURL=map-solution-to-draft-line-item.js.map
